var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebHeaderView'),_c('HomeSwipeView',{attrs:{"lst":_vm.imgLst}}),_c('HotShopsView'),_c('HomeProductView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }